
import ServiciosTabla from "@/components/servicios/TablaPrestados.vue";
import { useAdminComarca } from "@/composable/useAdminComarca";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import Page from "@/layout/Page.vue";
import { AuthModule, ServicioListadoModule } from "@/store/modules";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {
  computed,
  defineComponent,
  onActivated,
  onMounted,
  ref,
  watch,
} from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";

export default defineComponent({
  name: "servicios-prestados-listado",
  components: { Page, ServiciosTabla },

  setup() {
    const { t } = useI18n();
    const store = useStore();
    const module = getModule(ServicioListadoModule, store);
    const authModule = getModule(AuthModule, store);
    const authComarcaId = authModule.user.comarcaId;

    const { selectedComarcaId } = useAdminComarca();

    const error = computed(() => module.errors);

    watch(error, () => {
      if (!error.value) return;

      Swal.fire({
        text:
          t("errors." + (error.value.error.code ?? error.value.error.name)) ??
          error.value.error.name,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: t("dialogs.okButton"),
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    });

    const cargaListado = ref(false);

    const reloadListado = async () => {
      if (cargaListado.value) return;

      const isAdmin = !authComarcaId;

      // Admin: si no hay comarca elegida -> tabla vacia
      if (isAdmin && !selectedComarcaId.value) {
        module.setData([]);
        return;
      }

      // Determinar ID a enviar
      let idToFetch: string | undefined;
      if (isAdmin) {
        idToFetch =
          selectedComarcaId.value === "TODAS"
            ? undefined
            : selectedComarcaId.value!;
      } else {
        idToFetch = authComarcaId;
      }

      cargaListado.value = true;
      try {
        await module.fetchServiciosPrestados(idToFetch);
      } catch (err) {
        Swal.fire({
          text: t("formularios.serviciosPrestadosListado.cargar.error"),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      } finally {
        cargaListado.value = false;
      }
    };

    onActivated(async () => {
      await reloadListado();
    });

    onMounted(() => {
      setCurrentPageBreadcrumbs(t("menu.serviciosIndividuales"), [
        t("menu.servicios"),
      ]);
    });

    return {
      serviciosListado: computed(() => module.serviciosListado),
      cargaListado,
      reloadListado,
    };
  },
});
